import styled from 'styled-components';

import {
  Icon,
} from 'web-components';

const getBrandLogo = (brand) => {
  switch (brand) {
    case 'visa':
      return 'fab fa-cc-visa';
    case 'mastercard':
      return 'fab fa-cc-mastercard';
    case 'amex':
      return 'fab fa-cc-amex';
    case 'jcb':
      return 'fab fa-cc-jcb';
    case 'discover':
      return 'fab fa-cc-discover';
    case 'diners-club':
      return 'fab fa-cc-diners-club';
    case 'amazon-pay':
      return 'fab fa-cc-amazon-pay';
    case 'paypal':
      return 'fab fa-cc-paypal';
    case 'stripe':
      return 'fab fa-stripe';
    case 'apple-pay':
      return 'fab fa-cc-apple-pay';
    default:
      return 'fas fa-credit-card';
  }
};

export const CardIcon = styled(Icon).attrs(
  props => ({
    size: '24px',
    type: getBrandLogo(props.brand),
    color: props.theme.colors.primary,
  }),
)``;
